/* eslint-disable */

import 'react-widgets/dist/css/react-widgets.css';
import 'sweetalert2/src/sweetalert2.scss';

import React, { Component } from 'react';

import $ from 'jquery';
import { GSheetsAPIIntegrationTestFunc } from './GSheetsAPIIntegration';
import {OtpVerified} from './MessageDisplayPage'
import ReactDOM from 'react-dom';
import SignIn from './SignIn';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import _ from 'underscore';

class VerificationPage extends Component {

    constructor() {
        super()

        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        this.state = {
            //    password:"U2FsdGVkX19Iz9+nL7T1csE23Fi9+Ly5NYAEuzcZZi0=",
            password: 'Employee@123',
            holidayTableNextYear: "No",
            pinCode: '000000',
            thirdPartLogin: 'No',
            planName: "elite",
            permission: "avoidAttendanceTracking,supervisorAuthority,checkinout,manualAttendance,dailyAttendanceReport,"
                + "monthlyAttendanceReport,periodAttendanceReport,employeechartAttendanceReport,"
                + "employeeActivities,departmentActivities,roleActivities,permissionActivities,"
                + "supportCreateCase,addEmployeeExcel,updateEmployeeExcel,addLocationExcel,"
                + "employeeInformationReport,departmentwiseReport,singleswipeReport,statusUnknownReport,"
                + "lateCheckinReport,earlyCheckOutReport,auditReport,supportCaseHistory,locationActivities,"
                + "locateEmployee,addVehicle,trackVehicle,locateDevice,locateVehicle,"
                + "tripHistoryReport,deviceReport,attendanceRegularization,Leave,"
                + "leaveReport,leaveHistoryReport,sms,email,smsReport,emailReport,"
                + "shiftActivities,shiftMigration,shiftActivityCalendar,shiftOrganizationCalendar,"
                + "shiftAutomation,shiftReport,datewiseshiftReport,monthwiseShiftReport,"
                + "periodShiftReport,shiftVacancyReport,expiredShiftReport,shiftDeletedReport,supervisorsubordinateShiftReport,"
                + "scheduledShiftReport,shiftDeletedReport,workfromHomeConfiguration,workfromHomeDeleteFile,"
                + "workfromHomeReport,workfromHomeStatistics,workfromHomeBusinessAnalytics,"
                + "datewiseWorkfromHomeReport,monthlyWorkfromHomeReport,weeklyWorkfromHomeReport,"
                + "periodWorkfromHomeReport,workfromHomeAppInstalledReport,timesheetAttendance,"
                + "timesheetAdmin,timesheetReport,timesheetImport,timesheetExport,payment,"
                + "paymentHistoryReport,minimumWrkingHr,firstCheckInLastCheckOut,wifiSettings,"
                + "shiftConfigurations,holidayConfiguration,nonmandatoryfieldConfiguration,"
                + "companySettingsConfiguration,orderCreationAssignment,resourceReport,taskReport,assignedTaskReport",
            permissionHeader: "attendanceManagement,employeeMaintenance," +
                "trackingNavigation,requestApproval,communication,shiftManagement," +
                "workfromHome,timeSheet,paymentManagement,configuration,orderManagement",


        }



    }

    componentDidMount() {

        var self = this;
        var url = window.location.href;


        var uri = window.location.toString();
        //	alert("URI - "+uri);
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            //alert("CLEANED SUB URL - "+clean_uri);
            //alert("DOC-TITLE :"+ document.title);
            //window.history.replaceState({}, document.title, clean_uri);
            window.history.replaceState({}, document.title, "/");
        }

        this.DecodeTheURL(url);


    }

    DecodeTheURL(url) {


        var decodeComponent = decodeURIComponent(url);
        console.log("DECODE DATA:", decodeComponent);

        var url = new URL(decodeComponent);
        const params = new UrlParams(url.search);
        this.state.emailId = params.get("emailId");
        this.state.firstName = params.get("firstName");
        this.state.lastName = params.get("lastName");
        this.state.password = params.get("password");


        console.log("EMAIL ID:", this.state.emailId);
        console.log("FIRST NAME:", this.state.firstName);
        console.log("LAST NAME:", this.state.lastName);
        console.log("Password:", this.state.password);



        this.VerifySignUp()

        // GSheetsAPIIntegrationTestFunc(this.state.firstName,this.state.lastName,this.state.emailId);

    }

    VerifySignUp() {

        var self = this;
        var today = new Date();
        var date = toDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        var fromDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        today.setDate(today.getDate() + 14);

        var toDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();


        var self = this;

        $.ajax({
            type: 'POST',
            data: JSON.stringify({
                emailId: this.state.emailId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,

                siteName: '',
                password: this.state.password,
                mobileNo: '',
                address: '',
                city: '',
                country: '',
                pinCode: this.state.pinCode,
                state: '',
                companyType: '',
                planName: 'elite',
                permission: this.state.permission,
                permissionHeader: this.state.permissionHeader,
                trial: 'Yes',
                fromDate: fromDate,
                toDate: toDate,
                gstin: '',
                date: date,
                timeZone: '',
                area: '',
                holidayTableNextYear: '',
                zipCode: '',
            }),
            //  url: "http://localhost:8080/EmployeeAttendenceAPI/SignUpActivities/SignUpVerification",
            url: serverUrl+"/EmployeeAttendenceAPI/SignUpActivities/SignUpVerification",

            contentType: "application/json",
            dataType: 'json',
            async: false,

            success: function (data, textStatus, jqXHR) {

                console.log("BASIC DATA :", data);


                if (data.response == "Success") {


                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        text: "Your Eamil Id has been Verified Successfully",
                        timer: 2000
                    })



                    GSheetsAPIIntegrationTestFunc(self.state.firstName, self.state.lastName, self.state.emailId);


                    //  LoginFunc(self.state);       
                    //ReactDOM.render(<MailVerifiedMessage emailId={self.state.emailId} password={self.state.password} />, document.getElementById("root"));
                    ReactDOM.render(<OtpVerified />, document.getElementById("root"));


                } else if (data.response == "EmailId_AlreadyExist") {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        text: "You have already Regeistered with Tictoks",
                        timer: 2000
                    });
                    var uri = window.location.toString();
                    let clean_uri = uri.substring(0, uri.indexOf("?"));
                    window.history.replaceState({}, document.title, clean_uri);
                    ReactDOM.render(<SignIn />, document.getElementById("root"));

                }


            },
            error: function (data) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Network Connection Problem',
                    showConfirmButton: false,
                    timer: 2000
                })


            }

        });


    }






    render() {


        return (



            <div className="container" style={{ marginBottom: '0%', paddingTop: "0px" }}>

                <div id="feedbackformdiv">
                    <div class="" style={{ marginTop: "0px" }}>
                        <h4>VERIFICATION PAGE</h4>
                    </div>




                </div >

            </div>


        );
    }
}
class UrlParams {
    constructor(search) {
        this.qs = (search || location.search).substr(1);
        this.params = {};
        this.parseQuerstring();
    }
    parseQuerstring() {
        this.qs.split('&').reduce((a, b) => {
            let [key, val] = b.split('=');
            a[key] = val;
            return a;
        }, this.params);
    }
    get(key) {
        return this.params[key];
    }
}
export default VerificationPage;